export default {
  common: {
    explore: 'Explore Gallery',
    viewAll: 'View All Works',
    scanQR: 'Please scan the QR code with your phone',
  },
  home: {
    hero: {
      title: 'We made these memories for ourselves',
    },
    featured: {
      title: 'Featured Works',
    },
    about: {
      title: 'About the Photographer',
      content: 'I\'m a photographer who believes that photography is not just about capturing moments — it\'s about preserving emotions, telling stories, and holding on to the love that time often tries to fade. Inspired by songs like Photograph by Ed Sheeran, I strive to create images where eyes never close, hearts never break, and time stays frozen still. From weddings to quiet portraits, every click is my way of saying: this mattered, this was beautiful, this should be remembered. And I hope, when you look back at these photos, you\'ll remember not just how it looked — but how it felt.',
      quote: 'We keep this love in a photograph,we made these memories for ourselves.',
    },
    footer: {
      portfolio: 'Portfolio',
      gallery: 'Gallery',
      copyright: '© {{year}} Swain Photography. All rights reserved.',
    },
  },
  gallery: {
    all: 'All',
    landscape: 'Landscape',
    portrait: 'Portrait',
    documentary: 'Documentary',
    wedding: 'Wedding',
    ecosystem: 'Ecosystem',
    aircraft: 'Aircraft',
  },
  social: {
    douyin: 'Douyin',
    weibo: 'Weibo',
    rednote: 'Xiaohongshu',
    wechat: 'WeChat',
  },
}; 